const emptyState = {
  username: '',
  credit: 0,
  score: 0,
  full_name: '',
  avatar: ''
};

export const userReducer = (state = emptyState, { type, payload }) => {
  switch (type) {
    case 'SET_INFO':
      return {
        ...state,
        username: payload.username,
        credit: payload.credit,
        score: payload.score,
        full_name: payload.full_name,
        avatar: payload.avatar
      };

    default:
      return state;
  }
};
